export default __webpack_public_path__ + "static/media/no-img.5f09172c.png";